export const VIEWER_REPORT_BOOKING_MODEL_LIST = 'VIEWER_REPORT_BOOKING_MODEL_LIST'
export const VIEWER_REPORT_BOOKING_SEARCH = 'VIEWER_REPORT_BOOKING_SEARCH'
export const VIEWER_REPORT_BOOKING_PAGINATION = 'VIEWER_REPORT_BOOKING_PAGINATION'
export const VIEWER_REPORT_BOOKING_DROP_DOWN_SEARCH_TYPE = 'VIEWER_REPORT_BOOKING_DROP_DOWN_SEARCH_TYPE'
